import { TNotification } from '@/contexts/notificationsContext/domain/types';
import getNotificationMapping from '@/contexts/notificationsContext/domain/getNotificationMapping';

const getNotificationAdditionalInfo = (notification: TNotification) => {
  const notificationMapping = getNotificationMapping(notification.type, notification.payload);
  return notificationMapping?.additionalInfo;
};

export default getNotificationAdditionalInfo;
